import React from 'react'
import { ClaimForm } from 'components'

export default function Home() {
  return <ClaimForm />
}
